export default class EventTicketsCalendar {
    constructor($el) {
        this.$el = $el;
        this.$title = $el.querySelector('[data-event-tickets-calendar-title]');
        this.$grid = $el.querySelector('[data-event-tickets-calendar-grid]');
        this.$today = $el.querySelector('[data-event-tickets-calendar-today]');
        this.$prev = $el.querySelector('[data-event-tickets-calendar-prev]');
        this.$next = $el.querySelector('[data-event-tickets-calendar-next]');
        this.locale = document.documentElement.lang || 'nl-BE';
        this.eventsByDate = this.getEventsByDate();
        this.activeMonth = this.getInitialMonth();

        this.render = this.render.bind(this);

        this.$prev.addEventListener('click', () => {
            this.activeMonth = new Date(this.activeMonth.getFullYear(), this.activeMonth.getMonth() - 1, 1);
            this.render();
        });

        this.$next.addEventListener('click', () => {
            this.activeMonth = new Date(this.activeMonth.getFullYear(), this.activeMonth.getMonth() + 1, 1);
            this.render();
        });

        this.$today.addEventListener('click', () => {
            const now = new Date();

            this.activeMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            this.render();
        });

        this.render();
    }

    getEventsByDate() {
        return Array.from(this.$el.querySelectorAll('[data-event-tickets-calendar-ticket]'))
            .reduce((eventsByDate, $ticket) => {
                const date = this.normalizeDateKey($ticket.dataset.date);

                if (!date) {
                    return eventsByDate;
                }

                if (!eventsByDate[date]) {
                    eventsByDate[date] = [];
                }

                eventsByDate[date].push({
                    title: $ticket.dataset.title,
                    time: this.normalizeTime($ticket.dataset.time),
                    endTime: this.normalizeTime($ticket.dataset.endTime),
                    url: $ticket.dataset.url,
                });

                return eventsByDate;
            }, {});
    }

    normalizeTime(time) {
        if (!time) {
            return '';
        }

        return time.slice(0, 5);
    }

    normalizeDateKey(date) {
        if (!date) {
            return null;
        }

        const [year, month, day] = date.split('-');

        if (!year || !month || !day) {
            return null;
        }

        return [
            year,
            String(month).padStart(2, '0'),
            String(day).padStart(2, '0'),
        ].join('-');
    }

    getInitialMonth() {
        const sortedDates = Object.keys(this.eventsByDate).sort();

        if (!sortedDates.length) {
            const now = new Date();

            return new Date(now.getFullYear(), now.getMonth(), 1);
        }

        const [year, month] = sortedDates[0].split('-').map(Number);

        return new Date(year, month - 1, 1);
    }

    render() {
        const firstDay = new Date(this.activeMonth.getFullYear(), this.activeMonth.getMonth(), 1);
        const year = firstDay.getFullYear();
        const month = firstDay.getMonth() + 1;
        const numberOfDays = new Date(year, month, 0).getDate();
        const startOffset = (firstDay.getDay() + 6) % 7;
        const formatter = new Intl.DateTimeFormat(this.locale, {
            month: 'long',
            year: 'numeric',
        });

        this.$title.textContent = formatter.format(firstDay);
        this.$grid.innerHTML = '';

        for (let index = 0; index < 42; index += 1) {
            const dayNumber = index - startOffset + 1;
            const $day = document.createElement('article');

            $day.className = 'event-tickets__calendar__day';

            if (dayNumber < 1 || dayNumber > numberOfDays) {
                $day.classList.add('is-empty');
                this.$grid.appendChild($day);
                continue;
            }

            const dateKey = [
                year,
                String(month).padStart(2, '0'),
                String(dayNumber).padStart(2, '0'),
            ].join('-');
            const tickets = this.eventsByDate[dateKey] || [];
            const $dayLabel = document.createElement('span');

            $dayLabel.className = 'event-tickets__calendar__day-number';
            $dayLabel.textContent = dayNumber;
            $day.appendChild($dayLabel);

            if (tickets.length) {
                $day.classList.add('has-events');

                const $tickets = document.createElement('ul');

                $tickets.className = 'event-tickets__calendar__day-tickets';

                tickets.forEach((ticket) => {
                    const $ticket = document.createElement('li');
                    const $content = ticket.url ? document.createElement('a') : document.createElement('div');
                    const $time = document.createElement('strong');
                    const $title = document.createElement('span');

                    $ticket.className = 'event-tickets__calendar__day-ticket';
                    $content.className = 'event-tickets__calendar__day-ticket-link';
                    $time.className = 'event-tickets__calendar__day-ticket-time';
                    $time.textContent = ticket.endTime
                        ? `${ticket.time} – ${ticket.endTime}`
                        : ticket.time;
                    $title.textContent = ticket.title;

                    if (ticket.url) {
                        $content.href = ticket.url;
                    }

                    if (ticket.time) {
                        $content.appendChild($time);
                    }
                    $content.appendChild($title);
                    $ticket.appendChild($content);

                    $tickets.appendChild($ticket);
                });

                $day.appendChild($tickets);
            }

            this.$grid.appendChild($day);
        }
    }
}
